import React from 'react';
import {colors} from '../../utils/colors';
import {VECTORS} from './constants';

const Icon = ({name, size = 16, color = 'currentColor', cls, style}) => {
  if (name === 'symbol') {
    return (
      <svg
        width={size}
        height={size}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 300 300"
        style={style}
        className={cls}
      >
        <path
          fill={colors[color] || color}
          d="M214.69,178a12,12,0,1,1-12-12A12,12,0,0,1,214.69,178Zm-12-44a12,12,0,1,0,12,12A12,12,0,0,0,202.69,134Zm-7.57,64a12,12,0,0,0-16.6-3.53A28,28,0,0,1,135.31,171V143h39.08a12,12,0,0,0,0-24H135.31V97a20,20,0,0,0-20-20,4,4,0,0,0-4,4v38h-22a4,4,0,0,0-4,4,20,20,0,0,0,20,20h6v28a52,52,0,0,0,80.28,43.64A12,12,0,0,0,195.12,198Z"
        />
      </svg>
    );
  }
  if (name === 'loading') {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width={size}
        height={size}
        viewBox="0 0 100 100"
        preserveAspectRatio="xMidYMid"
        style={style}
        className={cls}
      >
        <g transform="rotate(0 50 50)">
          <rect x="43.5" y="1.5" rx="6.5" ry="12.5" width="13" height="25" fill={colors[color] || color}>
            <animate
              attributeName="opacity"
              values="1;0"
              keyTimes="0;1"
              dur="1s"
              begin="-0.9166666666666666s"
              repeatCount="indefinite"
            />
          </rect>
        </g>
        <g transform="rotate(30 50 50)">
          <rect x="43.5" y="1.5" rx="6.5" ry="12.5" width="13" height="25" fill={colors[color] || color}>
            <animate
              attributeName="opacity"
              values="1;0"
              keyTimes="0;1"
              dur="1s"
              begin="-0.8333333333333334s"
              repeatCount="indefinite"
            />
          </rect>
        </g>
        <g transform="rotate(60 50 50)">
          <rect x="43.5" y="1.5" rx="6.5" ry="12.5" width="13" height="25" fill={colors[color] || color}>
            <animate
              attributeName="opacity"
              values="1;0"
              keyTimes="0;1"
              dur="1s"
              begin="-0.75s"
              repeatCount="indefinite"
            />
          </rect>
        </g>
        <g transform="rotate(90 50 50)">
          <rect x="43.5" y="1.5" rx="6.5" ry="12.5" width="13" height="25" fill={colors[color] || color}>
            <animate
              attributeName="opacity"
              values="1;0"
              keyTimes="0;1"
              dur="1s"
              begin="-0.6666666666666666s"
              repeatCount="indefinite"
            />
          </rect>
        </g>
        <g transform="rotate(120 50 50)">
          <rect x="43.5" y="1.5" rx="6.5" ry="12.5" width="13" height="25" fill={colors[color] || color}>
            <animate
              attributeName="opacity"
              values="1;0"
              keyTimes="0;1"
              dur="1s"
              begin="-0.5833333333333334s"
              repeatCount="indefinite"
            />
          </rect>
        </g>
        <g transform="rotate(150 50 50)">
          <rect x="43.5" y="1.5" rx="6.5" ry="12.5" width="13" height="25" fill={colors[color] || color}>
            <animate
              attributeName="opacity"
              values="1;0"
              keyTimes="0;1"
              dur="1s"
              begin="-0.5s"
              repeatCount="indefinite"
            />
          </rect>
        </g>
        <g transform="rotate(180 50 50)">
          <rect x="43.5" y="1.5" rx="6.5" ry="12.5" width="13" height="25" fill={colors[color] || color}>
            <animate
              attributeName="opacity"
              values="1;0"
              keyTimes="0;1"
              dur="1s"
              begin="-0.4166666666666667s"
              repeatCount="indefinite"
            />
          </rect>
        </g>
        <g transform="rotate(210 50 50)">
          <rect x="43.5" y="1.5" rx="6.5" ry="12.5" width="13" height="25" fill={colors[color] || color}>
            <animate
              attributeName="opacity"
              values="1;0"
              keyTimes="0;1"
              dur="1s"
              begin="-0.3333333333333333s"
              repeatCount="indefinite"
            />
          </rect>
        </g>
        <g transform="rotate(240 50 50)">
          <rect x="43.5" y="1.5" rx="6.5" ry="12.5" width="13" height="25" fill={colors[color] || color}>
            <animate
              attributeName="opacity"
              values="1;0"
              keyTimes="0;1"
              dur="1s"
              begin="-0.25s"
              repeatCount="indefinite"
            />
          </rect>
        </g>
        <g transform="rotate(270 50 50)">
          <rect x="43.5" y="1.5" rx="6.5" ry="12.5" width="13" height="25" fill={colors[color] || color}>
            <animate
              attributeName="opacity"
              values="1;0"
              keyTimes="0;1"
              dur="1s"
              begin="-0.16666666666666666s"
              repeatCount="indefinite"
            />
          </rect>
        </g>
        <g transform="rotate(300 50 50)">
          <rect x="43.5" y="1.5" rx="6.5" ry="12.5" width="13" height="25" fill={colors[color] || color}>
            <animate
              attributeName="opacity"
              values="1;0"
              keyTimes="0;1"
              dur="1s"
              begin="-0.08333333333333333s"
              repeatCount="indefinite"
            />
          </rect>
        </g>
        <g transform="rotate(330 50 50)">
          <rect x="43.5" y="1.5" rx="6.5" ry="12.5" width="13" height="25" fill={colors[color] || color}>
            <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="0s" repeatCount="indefinite" />
          </rect>
        </g>
      </svg>
    );
  }

  if (!VECTORS[name]) return null;

  return (
    <svg
      width={size}
      height={size}
      fill={colors[color] || color}
      viewBox={VECTORS[name].viewBox}
      xmlns="http://www.w3.org/2000/svg"
      className={cls}
      style={style}
    >
      <path d={VECTORS[name].d} />
    </svg>
  );

  // switch (name) {
  //    case 'chart-pie':
  //       return <svg width={size} height={size} fill={colors[color} || color xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M461.29 288H224V50.71c0-8.83-7.18-16.21-15.74-16.21-.69 0-1.4.05-2.11.15C87.08 51.47-3.96 155.43.13 280.07 4.2 404.1 107.91 507.8 231.93 511.87c2.69.09 5.39.13 8.07.13 121.04 0 220.89-89.66 237.35-206.16 1.33-9.45-6.52-17.84-16.06-17.84zM240 480c-2.33 0-4.68-.04-7.02-.12-107.24-3.52-197.35-93.63-200.87-200.87C28.84 179.02 96.45 92.23 192 69.83V320h250.15C420.27 412.43 336.49 480 240 480zM288.8.04c-.35-.03-.7-.04-1.04-.04C279.1 0 272 7.44 272 16.23V240h223.77c9.14 0 16.82-7.69 16.2-16.8C503.72 103.74 408.26 8.28 288.8.04zM304 208V33.9c89.25 13.81 160.28 84.85 174.1 174.1H304z"/></svg>;
  //    case 'chart-donut':
  //       return <svg width={size} height={size} fill={colors[color} || color xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M456.433 371.72l-27.79-16.045c-7.192-4.152-10.052-13.136-6.487-20.636 25.82-54.328 23.566-118.602-6.768-171.03-30.265-52.529-84.802-86.621-144.76-91.424C262.35 71.922 256 64.953 256 56.649V24.56c0-9.31 7.916-16.609 17.204-15.96 81.795 5.717 156.412 51.902 197.611 123.408 41.301 71.385 43.99 159.096 8.042 232.792-4.082 8.369-14.361 11.575-22.424 6.92z"/></svg>;
  //    case 'arrow-right':
  //       return <svg width={size} height={size} fill={colors[color} || color xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M218.101 38.101L198.302 57.9c-4.686 4.686-4.686 12.284 0 16.971L353.432 230H12c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h341.432l-155.13 155.13c-4.686 4.686-4.686 12.284 0 16.971l19.799 19.799c4.686 4.686 12.284 4.686 16.971 0l209.414-209.414c4.686-4.686 4.686-12.284 0-16.971L235.071 38.101c-4.686-4.687-12.284-4.687-16.97 0z"/></svg>
  //    default:
  //       return null;
  // }
};

export default Icon;
